/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_SuccessInputs */



/**
* | output |
* | --- |
* | "External work order publish was successful." |
*
* @param {Work_Order_Publish_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_success = /** @type {((inputs?: Work_Order_Publish_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La publication de l’ordre de travail externe a réussi.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Veröffentlichung des externen Arbeitsauftrags war erfolgreich.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La pubblicazione dell'ordine di lavoro esterno è avvenuta correttamente.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Публикация внешнего задания прошла успешно.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La publicación de la orden de trabajo externa fue exitosa.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("外部工单发布成功。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("外部作業指示書の公開が成功しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बाह्य कार्य आदेश का प्रकाशन सफलतापूर्वक हो गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A publicação da ordem de serviço externa foi bem-sucedida.")
	return /** @type {LocalizedString} */ ("External work order publish was successful.")
});